"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconUndo = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 21 18",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M10.5,2.7 L10.5,-1.5 L5.1875,3.75 L10.5,9 L10.5,4.8 C14.016875,4.8 16.875,7.6245 16.875,11.1 C16.875,14.5755 14.016875,17.4 10.5,17.4 C6.983125,17.4 4.125,14.5755 4.125,11.1 L2,11.1 C2,15.741 5.80375,19.5 10.5,19.5 C15.19625,19.5 19,15.741 19,11.1 C19,6.459 15.19625,2.7 10.5,2.7 Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconUndo')(IconUndo);